export default __webpack_public_path__ + "static/media/gesundheitpflegesignet.cf2ce151.png";